import type {
  SupplierPaymentInformationUpdateRequestType,
  SupplierPaymentInformationUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useSupplierPaymentInformationUpdate = (
  supplierId: number,
  supplierPaymentInformationId: number,
) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: SupplierPaymentInformationUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `suppliers/${supplierId}/supplier-payment-information/${supplierPaymentInformationId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as SupplierPaymentInformationUpdateResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SuppliersPaymentInformation,
          supplierPaymentInformationId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SuppliersPaymentInformation,
        ],
      });
    },
  });
};
